import { render } from "./Smiles802.vue?vue&type=template&id=5afd6c51"
import script from "./Smiles802.vue?vue&type=script&lang=js"
export * from "./Smiles802.vue?vue&type=script&lang=js"

import "./Smiles802.vue?vue&type=style&index=0&id=5afd6c51&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__